(function () {
  angular.module("akitabox.ui.dialogs.externalQrScanner", [
    "ngMaterial",
    "akitabox.core.utils",
    "akitabox.core.services.qrcode",
  ]);
})();
